export default "__VITE_ASSET__DBULAYYp__"